<template>
	<div class="chat-setting-b-container">
		<div class="chat-setting-b-title">基础设置</div>
		<div class="chat-setting-b-box">
			<div class="chat-setting-b-item">
				<label>提示音</label>
				<div class="chat-setting-b-input">
					<span :class="{'chat-setting-b-checked': config.newMsgMusic}" @click="config.newMsgMusic = !config.newMsgMusic"></span>
				</div>
			</div>
			<div class="chat-setting-b-item">
				<button @click="saveConfig">保存</button>
			</div>
		</div>
	</div>
</template>

<script>
	import {getLocalConfigList,saveLocalConfig} from '../../../functions/Common.js'
	
	export default{
		name:'ChatSettingBasic',
		data(){
			return{
				config:{
					
				}
			}
		},
		methods:{
			// 保存配置项
			saveConfig(){
				CHAT_LAYER.msg('保存成功！')
				saveLocalConfig(this.config)
			}
		},
		created() {
			this.config = getLocalConfigList()
		}
	}
</script>

<style>
	.chat-setting-b-container{
		width: 100%;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
		position: relative;
	}
	.chat-setting-b-container .chat-setting-b-title{
		height: 50px;
		line-height: 50px;
		padding: 0 10px;
		border-bottom: 1px solid #d9d9d9;
	}
	.chat-setting-b-container .chat-setting-b-box{
		width: 100%;
		color: #666666;
	}
	.chat-setting-b-box .chat-setting-b-item{
		height: 40px;
		line-height: 40px;
		padding: 0 10px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.chat-setting-b-item label{
		display: block;
		width: 70px;
	}
	.chat-setting-b-item .chat-setting-b-input{
		width: 200px;
		height: 40px;
	}
	.chat-setting-b-input span{
		display: block;
		width: 16px;
		height: 40px;
		background-position: center;
		background-repeat: no-repeat;
		background-size: 100% auto;
		background-image: url(../../../assets/img/select-out.png);
		cursor: pointer;
	}
	.chat-setting-b-input .chat-setting-b-checked{
		background-image: url(../../../assets/img/select-in.png) !important;
	}
	.chat-setting-b-item button{
		height: 24px;
		padding: 0 10px;
		color: #FFFFFF;
		background-color: #009688;
		border-radius: 2px;
		cursor: pointer;
	}
</style>
